var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note-awards"},[_c('awards-list',{attrs:{"awards":_vm.awards,"can-award-emoji":_vm.canAwardEmoji,"current-user-id":_vm.getUserData.id},on:{"award":function($event){return _vm.handleAward($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }